import { CONTACT_CONSTANTS } from "@/features/survey/components/coverSection/constants";
import { EmeraldButton } from "@emerald-react/button";
import { EmeraldSearch } from "@emerald-react/search";
import useSurveyState from "@hooks/useSurveyState";
import { ContactForm } from "@survey-cover/ContactForm";
import { useAvailableContacts } from "@survey-cover/contacts/hooks/useAvailableContacts";
import { useContactActions } from "@survey-cover/contacts/hooks/useContactActions";
import { useContactSearch } from "@survey-cover/contacts/hooks/useContactSearch";
import SortableContactList from "@survey-cover/contacts/SortableContactList";
import { useState } from "react";

const ContactList = () => {
  const { survey } = useSurveyState();

  const [showCreateContact, setShowCreateContact] = useState(false);

  const contacts = survey?.contacts ?? [];
  const teamId = typeof survey?.teamId === "string" ? survey.teamId : undefined;
  const projectId =
    typeof survey?.projectId === "string" ? survey.projectId : undefined;

  const { allContacts } = useAvailableContacts(teamId, projectId);

  // Search functionality
  const {
    searchValue,
    searchSuggestions,
    noResultsOption,
    handleSearchChange,
    clearSearch,
  } = useContactSearch(allContacts, contacts);

  const { handleSelectContact } = useContactActions();

  const handleCreateSuccess = () => {
    setShowCreateContact(false);
    clearSearch();
  };

  const handleSelectContactWrapper = async (selected: unknown) => {
    await handleSelectContact(selected);
    clearSearch();
  };

  const sortedContacts = [...contacts].sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0),
  );

  return (
    <div className="flex flex-col gap-y-2 mt-2 border-t border-solid border-divider-3 pt-4">
      <div>Brokerage Team Contact Info</div>
      <div className="text-sm">
        You can search for the contact you want to add or create a new contact
        to add them to your cover page.
      </div>

      <EmeraldSearch
        placeholder="Search for contact to add"
        showSuggestions={
          searchValue.length > CONTACT_CONSTANTS.SEARCH.MIN_LENGTH
        }
        maxSuggestions={CONTACT_CONSTANTS.SEARCH.MAX_SUGGESTIONS}
        value={searchValue}
        options={[...noResultsOption, ...searchSuggestions]}
        onChange={handleSearchChange}
        onSelect={handleSelectContactWrapper}
        onClear={clearSearch}
      />

      {!showCreateContact && (
        <EmeraldButton
          icon="add"
          label="Create Contact"
          type="TextButton"
          onClick={() => setShowCreateContact(true)}
          className="create-contact"
          id="SC-AddContactInfo"
        />
      )}

      {showCreateContact && <ContactForm onSuccess={handleCreateSuccess} />}

      {sortedContacts.length > 0 && (
        <SortableContactList contacts={sortedContacts} />
      )}
    </div>
  );
};

// Add displayName for better debugging
ContactList.displayName = "ContactList";

export default ContactList;
